import GraphQlService from 'epic-node-services/src/graphql/GraphQlService';

class VideoApi {
    async getVideoManifest(mediaRefId) {
        return await GraphQlService.query(
            `{ Media {
                    getMediaRef(mediaRefId: "${mediaRefId}" ) {
                        accountId
                        outputs {
                            duration
                            url
                            width
                            height
                            key
                            contentType
                        }
                        namespace
                    }
                }}`
        ).catch(err => ({errors: err}));
    }
}

export default VideoApi;
